import { render, staticRenderFns } from "./userIndex.vue?vue&type=template&id=659bf04b&scoped=true&"
import script from "./userIndex.vue?vue&type=script&lang=js&"
export * from "./userIndex.vue?vue&type=script&lang=js&"
import style0 from "./userIndex.vue?vue&type=style&index=0&id=659bf04b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659bf04b",
  null
  
)

export default component.exports